import { memo } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip, type TooltipProps } from 'recharts';
import { type NameType, type ValueType } from 'recharts/types/component/DefaultTooltipContent';
import type { ConnectorUptimeSummary } from 'types/swagger';

interface Props {
  id: number;
  uptimeSummary: ConnectorUptimeSummary;
}

const HeartbeatDonutChart: React.FC<Props> = (props) => {
  const { uptimeSummary } = props;

  const chartData = [
    {
      name: 'Disponible',
      value: parseFloat(uptimeSummary?.Idle),
      color: '#FFFFFF',
    },
    {
      name: 'Ocupado',
      value: parseFloat(uptimeSummary?.Charging),
      color: '#00FF7F',
    },
    {
      name: 'Con falla',
      value: parseFloat(uptimeSummary?.Faulted),
      color: '#C51462',
    },
    {
      name: 'Fuera de línea',
      value: parseFloat(uptimeSummary?.Offline),
      color: '#808080',
    },
  ];

  const CustomTooltip = ({ active, payload }: TooltipProps<ValueType, NameType>) => {
    if (active && payload?.length) {
      return (
        <div className="custom-tooltip__container-gray">
          <div className="custom-tooltip__label">
            <span>{`${payload[0].value as string}% ${payload[0].name}`}</span>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: 200, height: 200 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            dataKey="value"
            innerRadius={56}
            outerRadius={98}
            startAngle={90}
            endAngle={-270}
            stroke="none"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

const propsAreEqual = (prevProps: Props, nextProps: Props) => {
  return (
    prevProps.id === nextProps.id &&
    JSON.stringify(prevProps.uptimeSummary) === JSON.stringify(nextProps.uptimeSummary)
  );
};

export default memo(HeartbeatDonutChart, propsAreEqual);
